import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const careersModalOverImageBlockFields = `
  _id,
  _type,
  backgroundImage {
    ${imageFields}
  },
  mainText,
  buttonLink {
    ${inlineCtaFields}
  }
`

export const CAREERS_MODAL_OVER_IMAGE_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-modal-over-image-block"][0]{
    ${careersModalOverImageBlockFields}
  }
`)
